import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_UPI_ENABLED_FOR = defineFcm('upi_enabled_for')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				safe_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
				block_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
			},
		}),
	)
	.withDefault({
		enabled: false,
		safe_listed_user_identifiers: undefined,
		block_listed_user_identifiers: undefined,
	})
	.toConfig();
